import { render, staticRenderFns } from "./list.html?vue&type=template&id=54e49914&scoped=true&"
import script from "./list.js?vue&type=script&lang=js&"
export * from "./list.js?vue&type=script&lang=js&"
import style0 from "./list.scss?vue&type=style&index=0&id=54e49914&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e49914",
  null
  
)

export default component.exports